import React, { useState, useEffect, useContext } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import noAvatarImg from "../../../assets/noAvatar.png";
import { AuthContext } from "../../../context/authContext";
import { decryptMessage } from "../../../utils/cryptoUtils";

export const ChatItem = React.memo(({ chat, selectChat, handleOpenDeleteModal }) => {
    const { privateKey } = useContext(AuthContext);
    const [displayMessage, setDisplayMessage] = useState("");

    useEffect(() => {
        let isMounted = true; 

        const decode = async () => {
            let text = chat.lastMessage;
            
            if (!text) {
                if (isMounted) setDisplayMessage("");
                return;
            }

            const isAttachmentNote = text.startsWith("[") && text.endsWith(" attached]");
            if (isAttachmentNote) {
                if (isMounted) setDisplayMessage(text);
                return;
            }

            if (privateKey) {
                try {
                    const decryptedText = await decryptMessage(text, privateKey);
                    if (isMounted) setDisplayMessage(decryptedText);
                } catch (error) {
                    if (isMounted) setDisplayMessage("[Secure message]");
                }
            }
        };

        decode();

        return () => {
            isMounted = false;
        };
    }, [chat.lastMessage, privateKey]); 

    return (
        <div 
            className="items"
            onClick={() => selectChat(chat)}
            style={{ backgroundColor: chat?.isSeen ? "transparent" : "rgba(81, 131, 254, 0.15)" }}
        >
            <img src={chat.receiverProfilePic || noAvatarImg} alt="" />

            <div className="texts">
                <span>
                    {chat.receiverName}
                </span>

                <p style={{ 
                        fontWeight: chat?.isSeen ? 300 : 600,
                        color: chat?.isSeen ? "inherit" : "#fff",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "200px" 
                    }}
                >
                    {displayMessage}
                </p>
            </div>

            <div 
                className="deleteBtn" 
                onClick={(e) => handleOpenDeleteModal(e, chat)}
                title="Delete the conversation"
            >
                <DeleteOutlineIcon />
            </div>
        </div>
    );
});